/**
 * LocalStorage implementation of TokenStorage
 */
export class LocalTokenStorage {
    constructor(prefix = 'ptek_auth_') {
        Object.defineProperty(this, "prefix", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.prefix = prefix;
    }
    getItem(key) {
        if (typeof window === 'undefined' || !window.localStorage) {
            return null;
        }
        return window.localStorage.getItem(this.prefix + key);
    }
    setItem(key, value) {
        if (typeof window === 'undefined' || !window.localStorage) {
            return;
        }
        window.localStorage.setItem(this.prefix + key, value);
    }
    removeItem(key) {
        if (typeof window === 'undefined' || !window.localStorage) {
            return;
        }
        window.localStorage.removeItem(this.prefix + key);
    }
    clear() {
        if (typeof window === 'undefined' || !window.localStorage) {
            return;
        }
        const keys = Object.keys(window.localStorage);
        keys.forEach((key) => {
            if (key.startsWith(this.prefix)) {
                window.localStorage.removeItem(key);
            }
        });
    }
}
/**
 * SessionStorage implementation of TokenStorage
 */
export class SessionTokenStorage {
    constructor(prefix = 'ptek_auth_') {
        Object.defineProperty(this, "prefix", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.prefix = prefix;
    }
    getItem(key) {
        if (typeof window === 'undefined' || !window.sessionStorage) {
            return null;
        }
        return window.sessionStorage.getItem(this.prefix + key);
    }
    setItem(key, value) {
        if (typeof window === 'undefined' || !window.sessionStorage) {
            return;
        }
        window.sessionStorage.setItem(this.prefix + key, value);
    }
    removeItem(key) {
        if (typeof window === 'undefined' || !window.sessionStorage) {
            return;
        }
        window.sessionStorage.removeItem(this.prefix + key);
    }
    clear() {
        if (typeof window === 'undefined' || !window.sessionStorage) {
            return;
        }
        const keys = Object.keys(window.sessionStorage);
        keys.forEach((key) => {
            if (key.startsWith(this.prefix)) {
                window.sessionStorage.removeItem(key);
            }
        });
    }
}
/**
 * In-memory implementation of TokenStorage
 */
export class MemoryTokenStorage {
    constructor(prefix = 'ptek_auth_') {
        Object.defineProperty(this, "storage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new Map()
        });
        Object.defineProperty(this, "prefix", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.prefix = prefix;
    }
    getItem(key) {
        return this.storage.get(this.prefix + key) || null;
    }
    setItem(key, value) {
        this.storage.set(this.prefix + key, value);
    }
    removeItem(key) {
        this.storage.delete(this.prefix + key);
    }
    clear() {
        const keys = Array.from(this.storage.keys());
        keys.forEach((key) => {
            if (key.startsWith(this.prefix)) {
                this.storage.delete(key);
            }
        });
    }
}
/**
 * Factory function to create appropriate storage based on type
 */
export function createTokenStorage(type) {
    switch (type) {
        case 'localStorage':
            return new LocalTokenStorage();
        case 'sessionStorage':
            return new SessionTokenStorage();
        case 'memory':
            return new MemoryTokenStorage();
        default:
            return new MemoryTokenStorage();
    }
}
//# sourceMappingURL=storage.js.map